<template>
    <div>

        <div class="bg-white w-100 rounded shadow-md p-10 flex justify-center items-center">
            <div class="flex-auto overflow-x-auto mt-2" style="direction:rtl">
                <template v-for="item in history">
                    <span
                        class="px-2 py-0.5 m-1"
                        :class="getColor(item) + ((dateHistoryEnabled) ? ' cursor-pointer' : '')"
                        v-tooltip="{
                            content: getHistoryInformationText(item),
                            classes: 'inline-block absolute mb-5 z-10 py-2 px-3 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm opacity-100 transition-opacity duration-300 tooltip dark:bg-gray-700',
                            offset: 1000
                        }"
                        @click="loadHistoryFor(item.day)"
                    ></span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        history: {
            required: true,
            type: Array,
        },
        dateHistoryEnabled: {
            required: false,
            type: Boolean,
            default: true,
        }
    },
    methods: {
        getColor(item) {
            switch (item.score) {
                case 9:
                    return "bg-green-800";
                case 8:
                    return "bg-green-700";
                case 7:
                    return "bg-green-600";
                case 6:
                    return "bg-green-500";
                case 5:
                    return "bg-green-400";
                case 4:
                    return "bg-green-300";
                case 3:
                    return "bg-red-200";
                case 2:
                    return "bg-red-400";
                case 1:
                    return "bg-red-500";
                default:
                    return "bg-red-600";
            }
        },

        getHistoryInformationText(item) {
            return item.interruptionDayNotice;
        },

        loadHistoryFor(date) {
            if (!this.dateHistoryEnabled) return;

            if (window.location.hash.substring(1) !== date) {
                window.history.pushState({}, "ZAP-Hosting Status", document.URL.replace(/#.*$/, "") + "#" + date);
                window.dispatchEvent(new HashChangeEvent("hashchange"));
            }
        },
    }
}
</script>
